"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dateUtils_1 = require("../../dateUtils");
var Accessor_1 = require("../../models/Accessor");
// apply a fully inclusive date range window to the provided metricTable
exports.applyDateRangeWindow = function (metricTable, dateRange, timestampAccessor) {
    if (timestampAccessor === void 0) { timestampAccessor = Accessor_1.DefaultTimestampAccessor; }
    if (!dateRange) {
        return metricTable;
    }
    var windowedMetric = [];
    metricTable.forEach(function (point) {
        if (dateUtils_1.withinRange(dateRange, timestampAccessor(point))) {
            windowedMetric.push(point);
        }
    });
    return windowedMetric;
};
//# sourceMappingURL=applyDateRangeWindow.js.map